import {Box, Stack, Typography} from '@mui/material';
import Tutorial from 'presentation/components/Tutorial';
import {translations} from 'presentation/translations-new';
import React from 'react';
import type {CallBackProps, Placement, Step} from 'react-joyride';

const {billsTable, selectBills, autoPayment, history, confirm} =
	translations['pt-br'].privateFlow.myFinancial.openBills.tutorial;

interface OpenBillsTutorialProps {
	isMobile: boolean;
	hasSelectableRow: boolean;
}

export function OpenBillsTutorial({isMobile, hasSelectableRow}: OpenBillsTutorialProps) {
	function handleStepChange({type, step}: CallBackProps) {
		if (type === 'step:before') {
			if ((step.target as string) === '#payments-history-tab') {
				document.getElementById('content-container')?.scrollTo({top: 0, behavior: 'auto'});
			}
			if ((step.target as string) === '#open-bills-auto-payment-card') {
				document.getElementById('open-bills-auto-payment-card')?.scrollIntoView({
					behavior: 'smooth',
					block: 'center',
				});
			}
			if ((step.target as string) === '#open-bills-first-card-checkbox-mobile') {
				document.getElementById('open-bills-first-card-checkbox-mobile')?.scrollIntoView({
					behavior: 'auto',
					block: 'center',
				});
			}
		}
	}

	const steps: Step[] = [
		{
			target: isMobile ? '#open-bills-first-card-mobile' : '#open-bills-table',
			content: (
				<Stack>
					<Typography variant="subtitle1" fontWeight={600}>
						{billsTable.title}
					</Typography>
					<Typography variant="body2">
						{billsTable.description}{' '}
						<Box component="span" fontWeight={600}>
							{billsTable.boldWord}
						</Box>
						.
					</Typography>
				</Stack>
			),
			placement: (isMobile ? 'top' : 'bottom') as Placement,
			disableBeacon: true,
		},
		...(hasSelectableRow
			? [
					{
						target: isMobile ? '#open-bills-first-card-checkbox-mobile' : '#open-bills-first-row-checkbox',
						content: (
							<Stack>
								<Typography variant="subtitle1" fontWeight={600}>
									{selectBills.title}
								</Typography>
								<Typography variant="body2">{selectBills.description}</Typography>
							</Stack>
						),
						placement: 'top' as Placement,
						disableBeacon: true,
						disableScrolling: true,
					} satisfies Step,
				]
			: []),
		{
			target: '#open-bills-auto-payment-card',
			content: (
				<Stack>
					<Typography variant="subtitle1" fontWeight={600}>
						{autoPayment.title}
					</Typography>
					<Typography variant="body2">{autoPayment.description}</Typography>
				</Stack>
			),
			placement: 'bottom' as Placement,
			disableBeacon: true,
			disableScrolling: true,
		},
		{
			target: '#payments-history-tab',
			content: (
				<Stack>
					<Typography variant="subtitle1" fontWeight={600}>
						{history.title}
					</Typography>
					<Typography variant="body2">{history.description}</Typography>
				</Stack>
			),
			placement: 'bottom' as Placement,
			disableBeacon: true,
			disableScrolling: true,
		},
	];

	return (
		<Tutorial
			steps={steps}
			storageKey="@hapvida:new-bills-bemobi-tutorial"
			customButtonsLabels={{last: confirm, next: confirm}}
			customContainerWidth={isMobile ? 'calc(100vw - 32px)' : '328px'}
			disableScrolling={!isMobile}
			disableScrollParentFix={!isMobile}
			scrollOffset={120}
			onStepChange={handleStepChange}
		/>
	);
}
